import { Injectable } from "@angular/core";
import { EntityService } from "./entity.service";
import { JQueryHTTPClient } from "./JQueryHTTPClient";
import { Rest } from "./rest_client";

@Injectable()
export class ZoneService extends EntityService<any> {
  client: Rest.RestApplicationClient;
  constructor(private jquery: JQueryHTTPClient) {
    super();
    this.client = new Rest.RestApplicationClient(jquery);
  }

  create(arg0: Rest.Zone): Rest.RestResponse<Rest.Zone> {
    return this.client.Zone_create(arg0);
  }

  update(arg0: Rest.Zone): Rest.RestResponse<Rest.Zone> {
    return this.client.Zone_update(arg0);
  }

  getPage(
    arg0: Rest.ListPaginationRequest
  ): Rest.RestResponse<Rest.Page<Rest.Zone>> {
    return this.client.Zone_getPage(arg0);
  }

  getPageAndFilters(
    arg0: Rest.ListPaginationRequest
  ): Rest.RestResponse<Rest.ListPageAndFilters<Rest.Zone>> {
    return this.client.Zone_getPageAndFilters(arg0);
  }

  changeStatus(
    arg0: number[],
    queryParams?: { status?: boolean }
  ): Rest.RestResponse<void> {
    return this.client.Zone_changeStatus(arg0, queryParams);
  }

  // @ts-ignore
  find(
    arg0: string,
    queryParams?: { id?: number }
  ): Rest.RestResponse<Rest.Zone> {
    return this.client.Zone_find(arg0, queryParams);
  }
}
